let youtubeApiPromise = null;

function loadYouTubeAPI() {
  if (window.YT && window.YT.Player) {
    return Promise.resolve();
  }

  if (youtubeApiPromise) {
    return youtubeApiPromise;
  }

  youtubeApiPromise = new Promise((resolve) => {
    const previousCallback = window.onYouTubeIframeAPIReady;

    window.onYouTubeIframeAPIReady = function () {
      if (typeof previousCallback === 'function') {
        previousCallback();
      }

      resolve();
    };

    const script = document.createElement('script');
    script.src = 'https://www.youtube.com/iframe_api';
    script.async = true;

    document.head.appendChild(script);
  });

  return youtubeApiPromise;
}


document.addEventListener('DOMContentLoaded', function () {

  const videos = document.querySelectorAll(
    '.nesk-youtube, .nesk-youtube-normal'
  );

  videos.forEach(function (element) {

    const videoId = element.dataset.videoId;

    if (!videoId) return;

    const isShorts =
      element.classList.contains('nesk-youtube');


    /* サムネイル表示 */
    element.innerHTML = `
      <div
        class="nesk-youtube-thumbnail"
        style="
          position:relative;
          width:100%;
          height:100%;
          cursor:pointer;
          overflow:hidden;
          background:#000;
          display:flex;
          align-items:center;
          justify-content:center;
        "
      >

        <img
          src="https://i.ytimg.com/vi/${videoId}/hqdefault.jpg"
          alt="NESK Movie"
          loading="lazy"
          style="
            width:100%;
            height:100%;
            object-fit:cover;
            display:block;
          "
        >

        <div
          style="
            position:absolute;
            top:50%;
            left:50%;
            transform:translate(-50%,-50%);
            width:68px;
            height:68px;
            border-radius:50%;
            background:rgba(0,0,0,.65);
            display:flex;
            align-items:center;
            justify-content:center;
          "
        >

          <div
            style="
              width:0;
              height:0;
              border-top:11px solid transparent;
              border-bottom:11px solid transparent;
              border-left:18px solid white;
              margin-left:4px;
            "
          ></div>

        </div>

      </div>
    `;


    element.addEventListener('click', async function () {

      if (element.dataset.loaded === 'true') {
        return;
      }

      element.dataset.loaded = 'true';


      /* Shortsのみクリック時に9:16へ展開 */
      if (isShorts) {
        element.style.height = 'auto';
        element.style.aspectRatio = '9 / 16';
      }


      await loadYouTubeAPI();

      element.innerHTML = '';

      let playCount = 0;

      new YT.Player(element, {

        videoId: videoId,

        playerVars: {
          mute: 1,
          controls: 0,
          rel: 0,
          playsinline: 1,
          autoplay: 1
        },

        events: {

          onStateChange: function (event) {

            if (event.data === YT.PlayerState.ENDED) {

              playCount++;

              /* 最初の再生 + 2回ループ */
              if (playCount < 3) {
                event.target.seekTo(0);
                event.target.playVideo();
              }

            }

          }

        }

      });

    });

  });

});